import { render, staticRenderFns } from "./InvoiceDetailSummaryCard.vue?vue&type=template&id=66da3a65&"
import script from "./InvoiceDetailSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetailSummaryCard.vue?vue&type=style&index=0&id=66da3a65&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports